import rfdc from "rfdc";

// Clone function
const clone = rfdc();

export default clone;
